import {
  Box,
  Container,
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
  Paper,
  Dialog,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Button,
  MenuItem,
  FormHelperText,
  IconButton,
  InputAdornment,
  Modal,
  Typography,
  Tooltip,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import moment from 'moment';
import React from 'react';
import TaskDatePicker from '../../components/TaskTimeAndDatePicker/DatePicker';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import DateRangeComponent from '../../components/DateRangePicker/DateRangeComponent';
import { useDispatch, useSelector } from 'react-redux';
import KeycloakService from '../../services/KeycloakService';
import { createTask, updateTask } from '../../services/TaskServices';
import dayjs from 'dayjs';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import {
  getSecondsFromHHMMSS,
  getHHMMSSFromSeconds,
} from '../../utils/TimeConversionFunctions';
import {
  CANCEL_BUTTON_TEXT,
  ERROR_KEY,
  RESET_DATE_RANGE,
  SHOW_NOTIFICATION,
  SUBMIT_BUTTON_TEXT,
} from '../../constants';
import {
  APPRAISAL,
  DURATION,
  EXTERNAL,
  EXTERNAL_HOURS,
  PROJECT,
  SET_DATE_RANGE,
  TaskFieldError,
  TASK_DESCRIPTION,
  TASK_EDIT,
  TASK_EDIT_CLOSE,
  TASK_TILE,
  TASK_TYPE,
  WFH,
  WFO,
  WORK_FROM_HOME,
  WORK_FROM_OFFICE,
  YYYY_MM_DD,
} from './TaskConstants';
import { MAIN_BLUE } from '../../color';
import './TaskField.css';
import CloseIcon from '@mui/icons-material/Close';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

const TaskFieldCopy = (props) => {
  const userDataState = useSelector((state) => state.taskOperation);
  const currentUserId = KeycloakService.getUserDetail();
  const {
    userProjects,
    handleClose,
    getTask,
    editData,
    setSelectedTaskData,
    rows,
    dialogBoxRef,
    setPage,
    setPageNo,
  } = props;

  const [taskFormData, setTaskFormData] = React.useState({
    project: '',
    taskType: '',
    taskTitle: '',
    description: '',
    startDate: '',
    endDate: '',
  });

  const [fieldError, setFieldError] = React.useState({
    project: false,
    taskType: false,
    taskTitle: false,
    timeDuration: false,
  });
  const [errorMsg, setErrorMsg] = React.useState({
    project: '',
    taskType: '',
    taskTitle: '',
    timeDuration: '',
  });

  const [appraisal, setAppraisal] = React.useState(false);
  const [time, setTime] = React.useState('00:00');
  const [timepickerField, setTimepickerField] = React.useState(null);

  const [currentDate, setCurrentDate] = React.useState({
    date: userDataState.edit
      ? dayjs(editData.startDate)
      : dayjs(moment(new Date()).format(YYYY_MM_DD)),
  });
  const [multipleTasks, setMultipleTasks] = React.useState([
    {
      date: moment(new Date()).format(YYYY_MM_DD),
      timings: [
        {
          date: moment(new Date()).format(YYYY_MM_DD),
          title: '',
          description: '',
          project: '',
          taskType: '',
          approverID: '',
          isAppraisal: false,
          officeHours: null,
          wfhHours: 0,
          externalHours: 0,
          timeError: false,
          timeErrorMsg: '',
          titleError: false,
          projectError: false,
        },
      ],
    },
  ]);
  const [dateRangeError, setDateRangeError] = React.useState(undefined);
  const [dateError, setDateError] = React.useState(undefined);
  const [timeError, setTimeError] = React.useState(undefined);
  const [timeErrorMsg, setTimeErrorMsg] = React.useState('');
  const [loadingApiCall, setLoadingApiCall] = React.useState(false);
  const dispatch = useDispatch();

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const [dateRange, setDateRange] = React.useState([
    {
      startDate: '',
      endDate: '',
    },
  ]);
  const getMultiTime = (index, timingsIndex) => {
    const date = moment(multipleTasks[index].date).startOf('day');
    const setTimings = multipleTasks[index].timings[timingsIndex].officeHours;

    if (setTimings !== null) {
      const timeArr = setTimings.split(':');
      const timeObj = date
        .clone()
        .add(timeArr[0], 'hours')
        .add(timeArr[1], 'minutes');

      return timeObj.toDate();
    }

    return null;
  };
  const handleChangeForRangeSelection = (e, index, timingsIndex) => {
    setMultipleTasks((prevTasks) =>
      prevTasks.map((task, i) => {
        if (i === index) {
          const newTimings = [...task.timings];
          newTimings[timingsIndex] = {
            ...newTimings[timingsIndex],
            officeHours: moment(new Date(e)).format('HH:mm'),
          };
          return { ...task, timings: newTimings };
        }
        return task;
      }),
    );
  };

  const handleChangeForTaskTitle = (event) => {
    setTaskFormData((prevRow) => {
      return { ...prevRow, [event.target.name]: event.target.value };
    });
  };
  const handleChangeForWFOTaskTitle = (event, index, timingsIndex) => {
    setMultipleTasks(
      multipleTasks.map((task, i) => {
        if (i === index) {
          return {
            ...task,
            timings: task.timings.map((timing, j) => {
              if (j === timingsIndex) {
                return {
                  ...timing,
                  title: event.target.value,
                  titleError: false,
                };
              }
              return timing;
            }),
          };
        }
        return task;
      }),
    );
  };

  const handleChangeForWFOProject = (event, index, timingsIndex) => {
    setMultipleTasks(
      multipleTasks.map((task, i) => {
        if (i === index) {
          return {
            ...task,
            timings: task.timings.map((timing, j) => {
              if (j === timingsIndex) {
                return {
                  ...timing,
                  [event.target.name]: event.target.value,
                  projectError: event.target.value === '',
                };
              }
              return timing;
            }),
          };
        }
        return task;
      }),
    );
  };
  const handleAddTasktoDate = (event, index) => {
    setMultipleTasks((prevTasks) => [
      ...prevTasks.slice(0, index),
      {
        ...prevTasks[index],
        timings: [
          ...prevTasks[index].timings,
          {
            date: prevTasks[index].date,
            title: '',
            description: '',
            project: '',
            taskType: '',
            approverID: '',
            officeHours: null,
            isAppraisal: false,
            wfhHours: 0,
            externalHours: 0,
            timeError: false,
            timeErrorMsg: '',
            titleError: false,
            projectError: false,
          },
        ],
      },
      ...prevTasks.slice(index + 1),
    ]);
  };
  const handleRemoveTask = (event, index, timingsIndex) => {
    const updatedTimings = [
      ...multipleTasks[index].timings.slice(0, timingsIndex),
      ...multipleTasks[index].timings.slice(timingsIndex + 1),
    ];
    const newTasks = [
      ...multipleTasks.slice(0, index),
      { ...multipleTasks[index], timings: updatedTimings },
      ...multipleTasks.slice(index + 1),
    ];
    setMultipleTasks(newTasks);
  };
  const handleChangeForWFOTaskDescription = (event, index, timingsIndex) => {
    setMultipleTasks((prevTasks) =>
      prevTasks.map((task, i) => {
        if (i === index) {
          return {
            ...task,
            timings: task.timings.map((timing, j) => {
              if (j === timingsIndex) {
                return {
                  ...timing,
                  description: event.target.value,
                };
              }
              return timing;
            }),
          };
        }
        return task;
      }),
    );
  };
  const handleChangeForTaskType = (event) => {
    if (editData.taskType === WFO) {
      setTaskFormData({
        ...taskFormData,
        taskTitle: '',
        description: '',
      });
    }
    setTaskFormData((prevRow) => {
      return { ...prevRow, [event.target.name]: event.target.value };
    });
  };

  const handleChangeForDescription = (event) => {
    setTaskFormData((prevRow) => {
      return { ...prevRow, [event.target.name]: event.target.value };
    });
  };

  const handleChangeForProject = (event) => {
    if (editData?.taskType === WFO) {
      if (event.target.value !== editData.projectName) {
        const updatedTasks = multipleTasks.map((item) => {
          const updatedTimings = item.timings.map((newTimings) => {
            const updatedElement = { ...newTimings };
            updatedElement.title = '';
            updatedElement.description = '';
            updatedElement.officeHours = null;
            updatedElement.wfhHours = 0;
            updatedElement.externalHours = 0;
            updatedElement.timeError = false;
            updatedElement.timeErrorMsg = '';
            updatedElement.titleError = false;
            return updatedElement;
          });
          return {
            ...item,
            timings: updatedTimings,
          };
        });
        console.log(updatedTasks);
        setMultipleTasks(updatedTasks);
      }
    } else if (editData?.taskType === EXTERNAL) {
      if (event.target.value !== editData.projectName) {
        setTaskFormData({
          project: '',
          taskType: '',
          taskTitle: '',
          description: '',
          startDate: '',
          endDate: '',
        });
        setTime('00:00');
        setTimepickerField(null);
        setCurrentDate(moment(new Date()).format(YYYY_MM_DD));
      }
    }
    setTaskFormData((prevRow) => {
      return { ...prevRow, [event.target.name]: event.target.value };
    });
  };
  const handleOnChangeAppraisal = () => {
    setAppraisal(!appraisal);
  };
  const handleOnWFOChangeAppraisal = (index, timingsIndex) => {
    setMultipleTasks(
      multipleTasks.map((task, i) => {
        if (i === index) {
          return {
            ...task,
            timings: task.timings.map((timing, j) => {
              if (j === timingsIndex) {
                return {
                  ...timing,
                  isAppraisal: !timing.isAppraisal,
                };
              }
              return timing;
            }),
          };
        }
        return task;
      }),
    );
  };

  const handleCancelForm = () => {
    dispatch({
      type: TASK_EDIT_CLOSE,
    });
    dispatch({
      type: RESET_DATE_RANGE,
    });
    setSelectedTaskData(() => {
      return {
        id: null,
        project: '',
        taskTitle: '',
        description: '',
      };
    });
    handleClose();
  };

  const onChangeTime = (value) => {
    setTimepickerField(value);
    setTime(moment(new Date(value)).format('HH:mm'));
  };

  const dataValidation = () => {
    if (taskFormData.taskType === WFO) {
      for (let i = 0; i < multipleTasks.length; i++) {
        for (let j = 0; j < multipleTasks[i].timings.length; j++) {
          hourValidation(multipleTasks[i].timings[j].officeHours, i, j);
        }
      }
      const newTasks = multipleTasks.map((task) => {
        const updatedTimings = task.timings.map((timing) => {
          const hasTitle =
            typeof timing.title === 'string' && timing.title.trim() !== '';
          const hasProject =
            typeof timing.project === 'string' && timing.project.trim() !== '';
          return {
            ...timing,
            titleError: !hasTitle,
            projectError: !hasProject,
          };
        });
        return {
          ...task,
          timings: updatedTimings,
        };
      });
      setMultipleTasks(newTasks);
      const hasErrors = multipleTasks.some((task) => {
        return task.timings.some((timing) => {
          return timing.timeError || timing.titleError || timing.projectError;
        });
      });

      if (hasErrors) {
        return false;
      }
      return true;
    }
    const fieldKeys = ['project', 'taskType', 'taskTitle'];

    for (let i = 0; i < fieldKeys.length; i++) {
      setFieldError(false);

      setErrorMsg((prev) => {
        return {
          ...prev,
          project: '',
          taskType: '',
          taskTitle: '',
          timeDuration: '',
        };
      });

      if (!Object.values(taskFormData)[i]) {
        setFieldError((prev) => {
          return { ...prev, [fieldKeys[i]]: true };
        });
        setErrorMsg((prev) => {
          return { ...prev, [fieldKeys[i]]: `${TaskFieldError.REQUIRED}` };
        });
        return false;
      }
    }
    if (taskFormData.taskType === 'EXTERNAL' && hourValidation(time) == 0) {
      setFieldError({ ...fieldError, timeDuration: true });
      return false;
    } else if (
      taskFormData.taskType === 'OFFICEHRS' &&
      hourValidation(time) == 0
    ) {
      return false;
    }

    return true;
  };

  const handleSubmitForTask = async () => {
    //  updating the already existing task
    if (editData?.employeeId) {
      if (dataValidation()) {
        const bodyPayload = createTaskBodyJSON(taskFormData);
        setLoadingApiCall(true);
        const updatedTaskResponse = await updateTask(bodyPayload);

        setLoadingApiCall(false);
        if (updatedTaskResponse.isError === false) {
          dispatch({
            type: TASK_EDIT_CLOSE,
          });
          handleClose();
          getTask();
          setPage(1);
          setPageNo(0);
          setSelectedTaskData(() => {
            return {
              id: null,
              project: '',
              taskTitle: '',
              description: '',
            };
          });
        }
        dipatchNotification(
          updatedTaskResponse.type,
          updatedTaskResponse.message,
        );
        dispatch({
          type: RESET_DATE_RANGE,
        });
        handleClose();
      }
    } else {
      // Condition for form validation for submit new task
      if (dataValidation()) {
        const bodyPayload = createTaskBodyJSON(taskFormData);
        setLoadingApiCall(true);
        const createTaskResponse = await createTask(bodyPayload);
        setLoadingApiCall(false);
        if (createTaskResponse.isError === false) {
          handleClose();
          getTask();
          setPage(1);
          setPageNo(0);
        }
        dipatchNotification(
          createTaskResponse.type,
          createTaskResponse.message,
        );
        dispatch({
          type: RESET_DATE_RANGE,
        });
        handleClose();
      }
    }
  };

  const onBlur = (event) => {
    const value = event.target.value;
    const validatedTime = hourValidation(value);
    setTime(getHHMMSSFromSeconds(validatedTime));
  };

  const onBlurMulti = (e, index, timingsIndex) => {
    let value = e.target.value;
    const time = hourValidation(value, index, timingsIndex);
    let newTasks = [...multipleTasks];
    newTasks[index].timings[timingsIndex].officeHours =
      getHHMMSSFromSeconds(time);
    setMultipleTasks(newTasks);
  };

  const handleTimeError = (timeError, timeErrorMsg, index, timingsIndex) => {
    let newTasks = multipleTasks;
    newTasks[index].timings[timingsIndex].timeError = timeError;
    newTasks[index].timings[timingsIndex].timeErrorMsg = timeErrorMsg;
    setMultipleTasks(newTasks);
  };

  const hourValidation = (value, index, timingsIndex) => {
    let sec = 0;
    if (value === null) {
      sec = 0;
    } else {
      sec = Math.max(0, getSecondsFromHHMMSS(value));
    }
    const secInADay = 23 * 60 * 60 + 59 * 60;
    setFieldError((prev) => {
      return { ...prev, timeDuration: false };
    });
    setErrorMsg((prev) => {
      return {
        ...prev,
        timeDuration: '',
      };
    });
    let hours = 0;
    let minutes = 0;
    if (value === null) {
      hours = 0;
      minutes = 0;
    } else {
      const [inputHours, inputMinutes] = value.split(':');
      hours = parseInt(inputHours, 10);
      minutes = parseInt(inputMinutes, 10);
    }
    // Convert the hours and minutes to numbers

    if (sec > secInADay || sec <= 0 || minutes > 59) {
      const newErrorMessage = TaskFieldError.INVALID_DURATION;
      setTimeErrorMsg(newErrorMessage);

      if (
        index == undefined ||
        index == null ||
        timingsIndex == null ||
        timingsIndex == undefined
      ) {
        setFieldError((prev) => {
          return { ...prev, timeDuration: true };
        });
        setErrorMsg((prev) => {
          return {
            ...prev,
            timeDuration: `${TaskFieldError.INVALID_DURATION}`,
          };
        });
      } else {
        handleTimeError(true, newErrorMessage, index, timingsIndex);
      }
      return 0;
    } else {
      if (index == undefined || index == null) {
        setFieldError((prev) => {
          return { ...prev, timeDuration: false };
        });
        setErrorMsg((prev) => {
          return {
            ...prev,
            timeDuration: '',
          };
        });
      } else {
        handleTimeError(false, '', index, timingsIndex);
      }
      return sec;
    }
  };

  const setTimingsError = (multipleTasks, index, timingsIndex) => {
    let newTasks = [...multipleTasks];
    newTasks[index].timings[timingsIndex].timeError = false;
    newTasks[index].timings[timingsIndex].timeErrorMsg = '';
    setMultipleTasks(newTasks);
  };

  React.useEffect(() => {
    if (editData?.employeeId) {
      setTaskFormData({
        ...taskFormData,
        ...{
          project: userProjects.find(
            (project) => project.projectId === editData.projectId,
          ).projectId,
          taskTitle: editData.timings[0].title,
          description: editData.timings[0].description,
          taskType: editData.taskType,
          startDate: editData.startDate,
          endDate: editData.endDate,
        },
      });
      dispatch({
        type: SET_DATE_RANGE,
        data: {
          startDate: new Date(editData.startDate).toISOString(),
          endDate: new Date(editData.endDate).toISOString(),
          key: '',
          color: MAIN_BLUE,
        },
      });
      if (editData.taskType === EXTERNAL) {
        const sec = editData.timings.map((item) => item.externalHours) / 1000;
        setTime(getHHMMSSFromSeconds(sec));
        setTimepickerField(
          new Date(
            Date.prototype.setHours.apply(
              new Date(),
              getHHMMSSFromSeconds(sec).split(':'),
            ),
          ),
        );
      } else if (editData.taskType === WFO) {
        let newTimeFieldEdit = [];
        let newTimings = editData.timings.map((timing) => {
          const newOfficeHours = getHHMMSSFromSeconds(
            timing.officeHours / 1000,
          );
          timing = { ...timing, officeHours: newOfficeHours };

          return timing;
        });
        const uniqueDates = [...new Set(newTimings.map((item) => item.date))];

        const updatedTasks = uniqueDates.map((date) => {
          const timings = newTimings
            .filter((item) => item.date === date)
            .map((item) => ({
              date: item.date,
              project: item.project,
              title: item.title,
              taskType: WFO,
              description: item.description,
              officeHours: item.officeHours,
              wfhHours: item.wfhHours,
              externalHours: item.externalHours,
              timeError: false,
              timeErrorMsg: '',
              titleError: false,
              projectError: false,
            }));

          return {
            date,
            timings,
          };
        });

        setMultipleTasks(updatedTasks);
      }

      setDateRange({
        startDate: editData.startDate,
        endDate: editData.endDate,
      });

      setAppraisal(editData.isAppraisal);
    }
  }, []);

  const onDateRangeSelection = (item) => {
    const dt = new Date(item.startDate);
    const enddate = new Date(item.endDate);
    let updatedData = [];
    let updatedTasks = [];
    while (dt <= enddate) {
      const element = [
        {
          date: moment(dt).format(YYYY_MM_DD),
          title: '',
          description: '',
          project: '',
          taskType: '',
          approverID: '',
          officeHours: null,
          wfhHours: 0,
          externalHours: 0,
          timeError: false,
          timeErrorMsg: '',
          titleError: false,
          projectError: false,
        },
      ];
      updatedData = [...updatedData, ...element];
      updatedTasks = [
        ...updatedTasks,
        ...[{ date: moment(dt).format('YYYY-MM-DD'), timings: element }],
      ];
      dt.setDate(dt.getDate() + 1);
    }
    setMultipleTasks(updatedTasks);

    setDateRange({
      ...{
        startDate: item.startDate,
        endDate: item.endDate,
      },
    });
  };

  const createTaskBodyJSON = (formBody) => {
    let updatedTasks = multipleTasks;
    if (formBody.taskType === WFO) {
      updatedTasks = multipleTasks.map((task) => {
        const updatedTimings = task.timings.map((timing) => {
          const seconds = getSecondsFromHHMMSS(timing.officeHours);
          timing.officeHours = seconds * 1000;
          timing.taskType = WFO;
          return timing;
        });
        task.timings = updatedTimings;
        return task;
      });
    }
    const updatedTimings = updatedTasks
      .reduce((acc, task) => {
        return acc.concat(task.timings);
      }, [])
      .map((timing) => {
        const {
          titleError,
          projectError,
          timeError,
          timeErrorMsg,
          approverID,
          ...rest
        } = timing;
        return rest;
      });
    const bodyJson = {
      employeeId: currentUserId,
      isAppraisal: appraisal,
      timings:
        formBody.taskType === WFO
          ? updatedTimings
          : [
              {
                date: moment(currentDate.date.toString()).format(YYYY_MM_DD),
                project: formBody.project,
                title: formBody.taskTitle,
                description: formBody.description,
                wfhHours: 0,
                externalHours:
                  formBody.taskType === EXTERNAL
                    ? Math.max(0, getSecondsFromHHMMSS(time)) * 1000
                    : 0,
                officeHours: 0,
              },
            ],
    };
    if (userDataState.edit) {
      bodyJson.id = rows[userDataState.rowId].id;
      bodyJson.timings.map((item, index) => {
        editData.timings.map((obj) => {
          if (obj.date == item.date) return (item.id = obj?.id);
        });
      });
    }
    return bodyJson;
  };

  return (
    <Container disableGutters>
      <Paper component={Box} elevation={0} p={4}>
        <Grid container>
          <Grid item md={12} mt={-2} xs={12}>
            <IconButton
              sx={{ mt: '0px', ml: '-8px' }}
              onClick={handleCancelForm}
            >
              <KeyboardBackspaceIcon />
            </IconButton>
            {taskFormData.taskType !== WFO ? (
              <FormGroup sx={{ float: 'right' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={handleOnChangeAppraisal}
                      checked={appraisal}
                    />
                  }
                  label={APPRAISAL}
                />
              </FormGroup>
            ) : null}
          </Grid>
          <Grid container>
            <Grid item md={7.68} xs={12}>
              <Grid item md={7} sm={12} xs={12} sx={{ mb: '15px' }}>
                <FormControl fullWidth error={fieldError.taskType}>
                  <InputLabel id="taskTypeSelect">{TASK_TYPE}</InputLabel>
                  <Select
                    fullWidth
                    name="taskType"
                    labelId="taskTypeSelect"
                    value={taskFormData.taskType}
                    label={TASK_TYPE}
                    onChange={handleChangeForTaskType}
                  >
                    <MenuItem value={EXTERNAL}>{EXTERNAL_HOURS}</MenuItem>
                    <MenuItem value={WFO}>{WORK_FROM_OFFICE}</MenuItem>
                  </Select>
                  <FormHelperText>{errorMsg.taskType} </FormHelperText>
                </FormControl>
              </Grid>
              {taskFormData.taskType !== WFO ? (
                <Grid item md={7} sm={12} xs={12} sx={{ mb: '15px' }}>
                  <FormControl fullWidth error={fieldError.project}>
                    <InputLabel id="taskProjectSelect">{PROJECT}</InputLabel>
                    <Select
                      name="project"
                      labelId="taskProjectSelect"
                      value={taskFormData.project}
                      label={PROJECT}
                      onChange={handleChangeForProject}
                    >
                      {userProjects.map((project) => (
                        <MenuItem value={project.projectId} key={project.id}>
                          {project.projectName}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errorMsg.project} </FormHelperText>
                  </FormControl>
                </Grid>
              ) : null}
              <Grid item md={7} sx={{ mb: '15px' }}>
                {taskFormData.taskType !== WFO ? (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      onViewChange={() => {
                        setFieldError((prev) => {
                          return { ...prev, timeDuration: false };
                        });
                        setErrorMsg((prev) => {
                          return {
                            ...prev,
                            timeDuration: '',
                          };
                        });
                      }}
                      PopperProps={{
                        sx: {
                          '& .css-1anqmj6-MuiPopper-root-MuiPickersPopper-root':
                            {
                              zIndex: 1300,
                              display: 'flex !important',
                              position: 'absolute !important',
                            },
                        },
                      }}
                      ampm={false}
                      label="Time"
                      value={timepickerField}
                      onChange={onChangeTime}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          onBlur={onBlur}
                          error={fieldError.timeDuration}
                          helperText={errorMsg.timeDuration}
                        />
                      )}
                    />
                  </LocalizationProvider>
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
            {taskFormData.taskType === WFO ? (
              <Grid
                item
                md={4.3}
                error={dateRangeError}
                sx={{ height: '385px' }}
              >
                <DateRangeComponent
                  onDateRangeSelection={onDateRangeSelection}
                  editData={editData}
                  maxDate={new Date()}
                />
              </Grid>
            ) : (
              <Grid item md={4.3} error={dateError}>
                <TaskDatePicker
                  date={currentDate}
                  setDate={setCurrentDate}
                  editData={editData}
                />
              </Grid>
            )}
          </Grid>

          {taskFormData.taskType === WFO && (
            <Grid item md={12} xs={12} style={{ marginTop: 10 }}>
              {multipleTasks.map((item, index) => (
                <Box key={index}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'row', md: 'row' },
                      marginBottom: { xs: 3, md: 3 },
                    }}
                  >
                    <Typography
                      sx={{
                        marginRight: { xs: 0, md: 3 },
                        marginY: { xs: 2 },
                      }}
                      size="small"
                    >
                      {moment(item.date).format('DD/MM/YYYY')}
                    </Typography>
                    <Tooltip title="Add a task">
                      <IconButton
                        onClick={(event) => {
                          handleAddTasktoDate(event, index);
                        }}
                      >
                        <AddCircleIcon color="success" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  {multipleTasks[index].timings.map((item, timingsIndex) => (
                    <Box
                      sx={{ marginBottom: { xs: 3, md: 6 } }}
                      key={timingsIndex}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: { xs: 'column', md: 'row' },
                        }}
                      >
                        <Box
                          sx={{
                            width: { xs: '100%', md: '25%' },
                            marginRight: { md: 2 },
                            marginBottom: { xs: 1 },
                          }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <TimePicker
                              PopperProps={{
                                sx: {
                                  '& .css-1anqmj6-MuiPopper-root-MuiPickersPopper-root':
                                    {
                                      zIndex: 1300,
                                      display: 'flex !important',
                                      position: 'absolute !important',
                                    },
                                },
                              }}
                              ampm={false}
                              label="Time"
                              onViewChange={() =>
                                setTimingsError(
                                  multipleTasks,
                                  index,
                                  timingsIndex,
                                )
                              }
                              value={getMultiTime(index, timingsIndex)}
                              onChange={(e) =>
                                handleChangeForRangeSelection(
                                  e,
                                  index,
                                  timingsIndex,
                                )
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onBlur={(e) =>
                                    onBlurMulti(e, index, timingsIndex)
                                  }
                                  error={item.timeError}
                                  helperText={item.timeErrorMsg}
                                  size="small"
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Box>
                        <Box
                          sx={{
                            width: { xs: '100%', md: '25%' },
                            marginRight: { md: 1 },
                            marginBottom: { xs: 1 },
                          }}
                        >
                          <FormControl
                            size="small"
                            fullWidth
                            error={
                              multipleTasks[index].timings[timingsIndex]
                                .projectError
                            }
                          >
                            <InputLabel id="taskProjectSelect">
                              {PROJECT}
                            </InputLabel>
                            <Select
                              name="project"
                              labelId="taskProjectSelect"
                              value={
                                multipleTasks[index].timings[timingsIndex]
                                  .project
                              }
                              label={PROJECT}
                              onChange={(event) => {
                                handleChangeForWFOProject(
                                  event,
                                  index,
                                  timingsIndex,
                                );
                              }}
                            >
                              {userProjects.map((project) => (
                                <MenuItem
                                  value={project.projectId}
                                  key={project.id}
                                >
                                  {project.projectName}
                                </MenuItem>
                              ))}
                            </Select>
                            {/* <FormHelperText>{errorMsg.project} </FormHelperText> */}
                          </FormControl>
                        </Box>
                        <Box sx={{ marginRight: { md: 1 } }}>
                          <TextField
                            name="taskTitle"
                            value={
                              multipleTasks[index].timings[timingsIndex].title
                            }
                            onChange={(event) => {
                              handleChangeForWFOTaskTitle(
                                event,
                                index,
                                timingsIndex,
                              );
                            }}
                            label={TASK_TILE}
                            size="small"
                            inputProps={{ maxLength: 50 }}
                            error={
                              multipleTasks[index].timings[timingsIndex]
                                .titleError
                            }
                          />
                        </Box>
                        <Box sx={{ width: '25%' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={() =>
                                  handleOnWFOChangeAppraisal(
                                    index,
                                    timingsIndex,
                                  )
                                }
                                checked={
                                  multipleTasks[index].timings[timingsIndex]
                                    .isAppraisal
                                }
                              />
                            }
                            label={APPRAISAL}
                          />
                        </Box>
                        {multipleTasks[index].timings.length > 1 ? (
                          <Box>
                            <Tooltip title="Remove">
                              <IconButton
                                onClick={(event) => {
                                  handleRemoveTask(event, index, timingsIndex);
                                }}
                              >
                                <CloseIcon color="error" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ) : null}
                      </Box>
                      <Box>
                        <TextField
                          name="description"
                          value={
                            multipleTasks[index].timings[timingsIndex]
                              .description
                          }
                          label={TASK_DESCRIPTION}
                          multiline
                          rows={2}
                          size="small"
                          inputProps={{ maxLength: 300 }}
                          onChange={(event) =>
                            handleChangeForWFOTaskDescription(
                              event,
                              index,
                              timingsIndex,
                            )
                          }
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))}
            </Grid>
          )}
          {taskFormData.taskType !== WFO && (
            <>
              <Grid item md={12} xs={12} sx={{ mb: '15px' }}>
                <TextField
                  name="taskTitle"
                  value={taskFormData.taskTitle}
                  onChange={handleChangeForTaskTitle}
                  label={TASK_TILE}
                  fullWidth
                  inputProps={{ maxLength: 50 }}
                  error={fieldError.taskTitle}
                  helperText={errorMsg.taskTitle}
                />
              </Grid>

              <Grid container>
                <Grid item md={12} xs={12} sx={{ mb: '15px' }} sm={12}>
                  <TextField
                    name="description"
                    value={taskFormData.description}
                    label={TASK_DESCRIPTION}
                    multiline
                    rows={4}
                    fullWidth
                    inputProps={{ maxLength: 300 }}
                    onChange={handleChangeForDescription}
                  />
                </Grid>
              </Grid>
            </>
          )}

          <Grid container className="space-between-container">
            <Grid item>
              <Button
                onClick={handleCancelForm}
                variant="outlined"
                color={ERROR_KEY}
              >
                {CANCEL_BUTTON_TEXT}
              </Button>
            </Grid>
            <Grid item>
              <LoadingButton
                onClick={() => handleSubmitForTask()}
                loading={loadingApiCall}
                variant="contained"
              >
                {loadingApiCall ? 'loading...' : SUBMIT_BUTTON_TEXT}
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default TaskFieldCopy;
